export default __webpack_public_path__ + "abeec182a7804d7edd3e7bf651644048.svg";